<template>
    <teleport to="#mobile-menu">
        <transition name="morph-button" mode="out-in">
            <div key="morph-button-wrapper">
                <button v-if="!display" @click="open" type="button" class="relative flex size-12 items-center justify-center transition hover:bg-zinc-900/15 text-white ml-2 -mt-[5px]" aria-label="Toggle navigation">
                    <span class="absolute top-0 left-0 size-12 [@media(pointer:fine)]:hidden"></span>
                    <svg class="size-8" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" data-slot="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"></path>
                    </svg>
                </button>
                <button v-if="display" @click="close" type="button" class="relative flex size-12 items-center justify-center transition hover:bg-zinc-900/15 text-white ml-2 -mt-[5px]" aria-label="Close navigation">
                    <span class="absolute top-0 left-0 size-12 [@media(pointer:fine)]:hidden"></span>
                    <svg class="size-8" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true" data-slot="icon">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"></path>
                    </svg>
                </button>
            </div>
        </transition>
    </teleport>

    <transition name="menu-slide" enter-active-class="animated faster slideInRight" leave-active-class="animated faster slideOutRight">
        <div class="mobile-menu-wrap border-t-2 border-blue-600" :class="classMenu" v-if="display">
            <div class="container-flex mx-auto px-4 xs:px-2 pt-3 relative" mt-1>
                <div v-for="(item, index) in links">
                    <template v-if="!displaySimpleMenu">
                        <div class="menu-item flex items-center cursor-pointer font-semibold xs:text-sm sm:text-sm" :class="{ 'border-b border-gray-500': index !== (links.length - 1) }" v-if="!checkSubLinks(item)">
                            <a :class="classLink" :href="getHref(item.link, item.parameter)">{{ item.label }}</a>
                        </div>
                        <div class="menu-item flex items-center cursor-pointer font-semibold xs:text-sm sm:text-sm" :class="{ 'border-b border-gray-500': index !== (links.length - 1) }" @click.prevent="select(item)" v-if="checkSubLinks(item)">
                            <a :class="classLink" :href="item.link">{{ item.label }}</a>
                            <i class="fas fa-angle-right ml-auto"></i>
                        </div>

                        <transition name="menu-slide" enter-active-class="animated faster slideInRight" leave-active-class="animated faster slideOutRight">
                            <div :class="classMenu" class="w-full" v-if="isActive(item)">
                                <div class="container-flex mx-auto px-4 xs:px-2">
                                    <button class="bg-blue-500 text-white text-sm font-semibold rounded btn-sm mt-2 ml-0" @click="back">
                                        <i class="fas fa-angle-double-left"></i>
                                        Back
                                    </button>
                                    <div class="mt-4 border-b-2 border-gray-500 font-semibold text-gray-800 pb-1 pl-1 mb-2 uppercase text-base">{{ active.label }}</div>
                                    <div :class="getSubLinkClass(subLink.link, subLink.parameter)" class="menu-item flex items-center font-semibold xs:text-sm sm:text-sm" v-for="(subLink, index) in active['sub-links']" :key="index">
                                        <a :class="classLink" :href="getHref(subLink.link, subLink.parameter)">{{ subLink.label }}</a>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </template>
                    <template v-else>
                        <div :class="getSubLinkClass(item.link, item.parameter)" class="menu-item flex items-center font-semibold xs:text-sm sm:text-sm">
                            <a :class="classLink" :href="getHref(item.link, item.parameter)">{{ item.label }}</a>
                        </div>
                    </template>
                </div>
                <div class="flex flex-wrap justify-center items-center p-3 mt-2 mb-2 -mx-2 bg-gray-100">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>


<script setup>
import {ref, computed, onMounted, onUnmounted} from 'vue';

const MAIN_CONTENT_CONTAINER = 'main-container';
const FOOTER_CONTAINER = 'footer';

const props = defineProps({
    links: Array,
    displaySimpleMenu: Boolean,
    current: String
});

const display = ref(false);
const active = ref(false);

// const activeLinks = computed(() => {
//     return active.value ? active.value['sub-links'] : [];
// });

const classMenu = computed(() => {
    return `bg-white absolute right-0 top-0 h-full w-full text-gray-800`;
});

const classLink = computed(() => {
    return `no-underline text-black w-full p-3`;
});

const getContainer = () => {
    return document.getElementById(MAIN_CONTENT_CONTAINER);
};

const getFooter = () => {
    return document.getElementById(FOOTER_CONTAINER);
};

const handleClose = (event) => {
    if ([event.target.id, event.target.parentElement?.id].includes(MAIN_CONTENT_CONTAINER)) {
        close();
    }
};

const handleResize = (event) => {
    if (window.matchMedia("(min-width: 768px)").matches) {
        close();
    }
};

const getSubLinkClass = (routeName, params) => {
    const isCurrent = getHref(routeName, params) === props.current;
    return `border-b border-gray-500 ${isCurrent ? 'text-black font-bold' : 'text-blue-500'}`;
};

const getHref = (routeName, params) => {
    return window.route(routeName, params).toString();
};

const open = () => {
    display.value = true;
    // const width = Math.max(document.documentElement.clientWidth * 0.666);
    const container = getContainer();
    container.classList.add('hidden');
    const footer = getFooter();
    footer.classList.add('hidden');
};

const close = () => {
    display.value = false;
    active.value = false;
    const container = getContainer();
    container.classList.remove('hidden');
    const footer = getFooter();
    footer.classList.remove('hidden');
};

const select = (item) => {
    active.value = item;
};

const back = () => {
    active.value = false;
};

const isActive = (item) => JSON.stringify(item) === JSON.stringify(active.value);

const checkSubLinks = (item) => {
    return item['sub-links'] ? true : false;
};

onMounted(() => {
    getContainer().addEventListener('click', handleClose);
    window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
    getContainer().removeEventListener('click', handleClose);
    window.removeEventListener('resize', handleResize);
});
</script>

<style lang="scss">
.mobile-menu-wrap {
    top: 5.5rem !important;
}

.menu-item {
    padding: 0;
}

.morph-button:focus {
    outline: none;
}

.morph-button {
    width: 80px;
    height: 27px;
}

.morph-button-enter-active {
    transition: all .1s ease;
}

.morph-button-leave-active {
    transition: all .1s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.morph-button-enter,
.morph-button-leave-to {
    transform: scale(0.8);
    opacity: 0;
}
</style>
